import {createSelector} from 'reselect';
import {getIsInJapanLoqateExperiment} from '../ExperimentSelectors';
import {getSettings} from '../selectors';
import checkShouldUseAddressLookup from './checkShouldUseAddressLookup';

export default country => createSelector(
  [getSettings, getIsInJapanLoqateExperiment],
  (settings, isInJapanLoqateExperiment) => {
    return !!checkShouldUseAddressLookup(country, settings, isInJapanLoqateExperiment);
  },
);
